import { Link } from 'react-router-dom';
import * as React from 'react';

import { MarketingFeeDetails } from 'src/common/models';

import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkMoreInfoTrigger } from 'uitk-react-more-info-trigger';

import { DisclaimerDialog } from 'src/common/components/common/disclaimer-dialog';

export interface MarketingFeeDetailsContainerProps {
  marketingFeeDetails?: MarketingFeeDetails;
  marketingFeeQuery?: any;
  marketingFeeDialogId?: string;
  handleClose?: () => void;
  alignmentClasses: string;
}

export const MarketingFeeDetailsContainer: React.FunctionComponent<MarketingFeeDetailsContainerProps> = ({
  marketingFeeDetails,
  marketingFeeQuery,
  marketingFeeDialogId,
  handleClose,
  alignmentClasses
}) => (
  <React.Fragment>
    {marketingFeeDetails &&
      marketingFeeDetails.tierName && (
        <div className={`uitk-grid ${alignmentClasses}`}>
          <UitkMoreInfoTrigger>
            <Link to={marketingFeeQuery}>
              <UitkIcon name={marketingFeeDetails.tierIcon} className="pwa-theme--grey-700" />
              <span className="uitk-type-regular pwa-theme--grey-700 truncate">{marketingFeeDetails.tierName}</span>
              <UitkIcon name="info_outline" className="pwa-theme--grey-700" size={UitkIconSize.SMALL} />
            </Link>
          </UitkMoreInfoTrigger>
          <DisclaimerDialog
            dialogType="pwaDialog"
            disclaimerText={marketingFeeDetails.marketingFeeMessage}
            innerHTML={true}
            layerId="price-marketing-fee-dialog"
            disclaimerTextId="price-marketing-fee-text"
            dialogId={marketingFeeDialogId}
            handleClose={handleClose}
          />
        </div>
      )}
  </React.Fragment>
);
